export interface EntityConstants {
	apiEndpoint: string,
	navigateToParent: string,
	entityLabel: string,
	entityLabelGender: string,
}
 
export const copyJson = (original: any) => {
	return JSON.parse(JSON.stringify(original))
}
 
export const forcedNumber = (value: any) => {
	if (value === null || value === undefined) return value
	if (typeof value === 'number') return value
	if (typeof value === 'string') return parseFloat(value)
	throw new Error('Invalid value')
}
 
export const capitalLetter = (value: string) => {
	if (!value) return ''
	if (value.length === 1) return value.toUpperCase()
	return value.charAt(0).toUpperCase() + value.substring(1)
}
 
export const getEntityWithArticle = (entityConstants: EntityConstants) => {
	return `${entityConstants.entityLabelGender === 'M' ? 'el' : 'la'} ${entityConstants.entityLabel.toLowerCase()}`
}

export const formatCurrency = (amount: number) => {
	return new Intl.NumberFormat('es-AR', {
		style: 'currency',
		currency: 'ARS',
		minimumFractionDigits: 0,
	}).format(amount)
}